export default __webpack_public_path__ + "c1f1091d38ac9a1b74ee26eb8000e62e.png";